import React, { useContext, useEffect, useState} from 'react'
import { LoadingContext, M_Button, M_InputTextField, BufferService } from '../M_Components'
import { useTranslation } from 'react-i18next'
import { Done } from '@mui/icons-material'

export default function ConfigSettings() {
  const ctx = useContext(LoadingContext)
  const { t } = useTranslation()
  const [settings, setSettings] = useState([])
  const [selectedSetting, setSelectedSetting] = useState(null)

  const bufferService = new BufferService('configurationType')

  useEffect(() => {
    const fetchSettings = async () => {
      ctx.setIsLoad(true)
      try {
        const response = await bufferService.get()
        if (response?.name === 'AxiosError') {
          ctx.toastMessages('error', response.response.data.Errors.toString(), '')
          return
        }
        const items = response || []
        setSettings(items)
        if (items.length > 0) setSelectedSetting(items[0])
      } catch (error) {
        ctx.toastMessages('error', t('ErrorLoadingSettings'), '')
      } finally {
        ctx.setIsLoad(false)
      }
    }
    fetchSettings()
  }, [t])

  const saveSettings = async () => {
    if (!selectedSetting) return
    const array = selectedSetting.Settings
    const bufferServiceSettings = new BufferService('SettingsEntity/updateAllSettings')

    try {
      const res = await bufferServiceSettings.put(array)
      if (res?.name === 'AxiosError') {
        ctx.toastMessages('error', res.response.data.Errors.toString(), '')
        return
      }
      ctx.toastMessages('success', '', t("SettingsSaved"))
    } catch (error) {
      ctx.toastMessages('error', t("ErrorSavingSettings"), '')
    }
  }

  return (
    <div className="divGlobalSettings" data-testid="settings-container">
      <div className="subTitleSettings">
        <div>
          <div style={{ color: ctx.secondaryColor }} data-testid="change-password-title">
            {t('Settings')}
          </div>
          <div className="labelSubtitleSettings" data-testid="change-password-info">
            {t("InfoSettings")}
          </div>
        </div>
      </div>

      <div className="divSettingsGlobal" style={{ display: "flex", gap: "20px" }}>

        <div className="menuSettings" style={{ minWidth: "250px" }}>
          {settings.map((setting) => (
            <div
              key={setting.Id}
              className={`divMenuSettings ${selectedSetting?.Id === setting.Id ? "active" : ""}`}
              style={{ cursor: "pointer", padding: "10px", borderBottom: "1px solid #ccc" }}
              onClick={() => setSelectedSetting(setting)}
            >
              <h3 style={{ color: 'var(--color-red-dark)' }}>{setting.Name}</h3>
              <p style={{ color: 'var(--color-grey-dark)' }} className='MenuSubtitleSettings'>{setting.Description}</p>
            </div>
          ))}
        </div>

        <div className="divFormSettings" style={{ flex: 1 }}>
          {selectedSetting ? (
            <div >
              <h2 style={{ color: 'var(--color-red-dark)' }}>{selectedSetting.Name}</h2>
              <div className='divItemFormSettings'>
                {selectedSetting.Settings?.map((field) => (
                  <div key={field.Id} >
                    <M_InputTextField
                      type={field.FieldType === 1 ? 'decimal' : 'text'}
                      label={field.Name}
                      value={field.Value || ""}
                      onChange={(e) => {
                        const updated = {
                          ...selectedSetting,
                          Settings: selectedSetting.Settings.map((f) =>
                            f.Id === field.Id ? { ...f, Value: e.target.value } : f
                          ),
                        }
                        setSelectedSetting(updated)
                        setSettings((prev) =>
                          prev.map((s) => (s.Id === updated.Id ? updated : s))
                        )
                      }}
                    />
                  </div>
                ))}
              </div>
              <div className='divButtonFormSettings'>
                <M_Button
                  label={t("Save")}
                  backgroundColor={'green'}
                  labelColor={'white'}
                  icon={<Done style={{ color: 'var(--color-white)' }} />}
                  onClick={saveSettings}
                />
              </div>
            </div>
          ) : (
            <p>Selecione um item no menu para editar as configurações</p>
          )}
        </div>
      </div>
    </div>
  )
}
